<template>
  <div style="height: 100%; padding: 0 20px; box-sizing: border-box; display: flex; align-items: center; justify-content: space-between;">

    <div>
      <span style="font-size: 14px; font-weight: 700;">{{ pageTitle }}</span>
    </div>

    <div style="width: 50%;">
      
      <div v-if="hide" class="tips-b">
        <i class="el-icon-info" style="font-size: 15px;"></i>&nbsp;<span>音频未激活</span>
        <span>（点击屏幕激活）</span>
      </div>

      <div v-else v-show="show" ref="refTips" class="success-tips-b">
        <i class="el-icon-success" style="font-size: 15px;"></i>&nbsp;<span>音频已激活</span>
      </div>

    </div>

    <div>
      <Avatar></Avatar>
    </div>

  </div>
</template>

<script>
  import Avatar from '@/components/header/avatar/index.vue'

  export default {
    name: '',
    props: { hide: Boolean },
    components: { Avatar },

    data() {
      return {
        show: true,
      }
    },

    methods: {
    },

    computed: {
      pageTitle() {
        return {
          // '/dashboard': '工作台',
          '/dashboard': '数据统计',
          '/addorder': '点餐',
          '/addorder/neworder': '菜品',
          '/table': '桌位管理',
          '/qrCode': '桌号管理',
          '/order': '订单管理',
          '/goods': '菜品管理',
          '/category': '分类管理',
          '/employee': '员工管理',
          '/user': '用户管理',
          '/set': '店铺配置',
          '/acctbook': '收支统计',
          '/printer': '打印机',
          '/cheftask': '后厨任务',
        } [this.$route.path] || ''
      }
    },

    watch: {
      hide(nV, oV) {
 
        setTimeout(() => {
          // this.$refs.refTips.style.display = 'none';
          this.show = false;
        }, 500)
      }
    }

  }      
</script>

<style scoped>
  .tips-b {
    width: 100%;
    line-height: 35px;
    padding-left: 10px;
    font-size: 14px;
    color: #909399;
    background-color: #f4f4f5;
    border-radius: 2px;
  }

  .success-tips-b {
    width: 100%;
    line-height: 35px;
    padding-left: 10px;
    font-size: 14px;
    color: #67c23a;
    background-color: #f0f9eb;
    border-radius: 2px;
  }

</style>